export function findScrollableParent(element: HTMLElement): HTMLElement | null {
	let parent = element.parentElement;

	while (parent) {
		const overflowY = window.getComputedStyle(parent).overflowY;
		if (overflowY === 'auto' || overflowY === 'scroll') {
			return parent;
		}
		parent = parent.parentElement;
	}

	return null;
}

export function scrollIntoViewWithAnimation(element: HTMLElement): void {
	if (!element) {
		return;
	}

	requestAnimationFrame(() => {
		if (element && document.body.contains(element)) {
			const scrollableParent = findScrollableParent(element);

			if (scrollableParent) {
				const elementRect = element.getBoundingClientRect();
				const containerRect = scrollableParent.getBoundingClientRect();

				const isFullyVisible =
					elementRect.top >= containerRect.top &&
					elementRect.bottom <= containerRect.bottom;

				if (!isFullyVisible) {
					element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				}
			} else {
				element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		}
	});
}
